import { AUTO_API } from '@constants/fastagConstants'
import { RESPONSE } from '@factories/vasApiResponseConstants'
import { API_URL_FACTORY } from '@factories/apiUrlFactory'

export const autoService = async (regNo): Promise<any> => {
  try {
    const apiUrl = API_URL_FACTORY.VEHICLE_INFO_API(regNo) ? API_URL_FACTORY.VEHICLE_INFO_API(regNo) : AUTO_API(regNo)
    const response = await fetch(apiUrl)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    // Return the fetched data
    return data
  } catch (err) {
    console.error(err, RESPONSE.ERROR_AUTO_API)
    return null
  }
}
